import * as React from 'react'
import {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'
import {IFormBase} from '../../lib/forms/IFormBase'
import {isFieldRequired} from '../../lib/helpers'

///////////////////////////////////////////////////////////////////////////////

export type LabelMarkRequiredWrapperProps = {
  children?: any
  form?: IFormBase<any>
  fields?: string | string[]
}

///////////////////////////////////////////////////////////////////////////////

export class LabelMarkRequiredWrapper extends Component<
  LabelMarkRequiredWrapperProps,
  any
> {
  private labelBlock: HTMLElement

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.labelBlock = findDOMNode(this) as HTMLInputElement

    if (this.labelBlock) {
      this.toggleLabelMarkRequired()
    }
  }

  componentDidUpdate() {
    if (this.labelBlock) {
      this.toggleLabelMarkRequired()
    }
  }

  toggleLabelMarkRequired() {
    let {
      labelBlock,
      props: {form, fields},
    } = this

    if (labelBlock) {
      if (isFieldRequired(form, fields)) {
        let mark = labelBlock.querySelector('.label-mark-required')

        if (!mark) {
          mark = document.createElement('span')
          mark.classList.add('label-mark-required')
          labelBlock.appendChild(mark)
        }
      } else {
        let mark = labelBlock.querySelector('.label-mark-required')

        if (mark) {
          labelBlock.removeChild(mark)
        }
      }
    }
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }
}
